<div class="container-fluid">
  <div class="row justify-content-center pt-4">
    <div class="col-6 col-md-5">
      <span class="rm-title rm-title-3">Syndication</span>&nbsp;
      <br/>
      <em style="color: orange;" *ngIf="!!syndication">
        {{ syndication.issuerPoolIsLocked ? 'Issuer has locked syndication pool' : 'Syndication pool is open' }}
      </em>
    </div>
    <div class="col-6 text-end" *ngIf="!!syndication && (util.isIssuer() || util.isAdmin())">
      <button mat-raised-button
              color="warn"
              (click)="changeLockStatus(false)"
              *ngIf="syndication.issuerPoolIsLocked == true"
              [hasPermission]="util.Permission.CAN_LOCK_DEAL_SYNDICATION"
      >
        UNLOCK Syndication Pool
      </button>
      <button mat-raised-button
              color="warn"
              (click)="changeLockStatus(true)"
              *ngIf="syndication.issuerPoolIsLocked == false"
              [hasPermission]="util.Permission.CAN_LOCK_DEAL_SYNDICATION"
      >
        Lock Syndication Pool
      </button>

    </div>
    <div class="col-6 text-end" *ngIf="!!syndication && util.isInvestor()">
      <button mat-raised-button *ngIf="util.isInvestor()"
        color="primary" 
        [hasPermission]="util.Permission.CAN_ADD_DEAL_SYNDICATION" [disabledOption1]="{ condition: syndication.issuerPoolIsLocked, message: 'Syndication pool is locked by issuer!' }" 
        (click)="subscribe()">
        Subscribe
      </button>
    </div>
    <!--      -->
    <!--      -->
    <!--     CARDS START-->
    <!--      -->
    <!--      -->
    <div *ngIf="syndication">
      <!-- Investor top cards  -->
      <div class="row justify-content-center pt-3">
        <div class="col-11 col-md-3 pool">
          <span class="title">Total Subscription Amount</span><br/><br/>
          <span class="value">{{ (syndication.totalFundraiseSize || 0) | currency: 'USD': 'symbol': '1.0-0' }} Million USD</span>
        </div>
        <div class="col-11 col-md-3 pool">
          <span class="title">Subscriptions in last 3 months</span><br/><br/>
          <span class="value">{{ (syndication.subscriptionsInLast3Months || 0) | currency: 'USD': 'symbol': '1.0-0' }} Million USD</span>
        </div>
        <div class="col-11 col-md-3 pool">
          <span class="title">Subscriptions in last month</span><br/><br/>
          <span class="value">{{ (syndication.subscriptionsInLastMonth || 0) | currency: 'USD': 'symbol': '1.0-0' }} Million USD</span>
        </div>

        <br /><br />
        <div *ngIf="syndication.dealSignersError" class="col-11 mb-1 mt-1" style="display: flex; gap: 5px; align-items: center; color: red; margin-left: 15px;">
          <mat-icon>error</mat-icon> <span>{{ syndication.dealSignersError }}</span>
        </div>

      </div>
    </div>
    <br/>

    <!--      -->
    <!--      -->
    <!--     TABLE START-->
    <!--      -->
    <!--      -->
    <div class="row justify-content-center d-none d-md-flex" *ngIf="!showSubDocsTableOnly" style="padding-bottom: 150px; padding-top: 15px;">
      <div class="col-11">
        <div class="table-container">
          <div class="row table-inner-container">
            <div class="table-inner-inner-container">
              <!--                -->
              <!-- SUBSCRIPTION TABLE START-->
              <!--                -->
              <table class="subscription-table"
                      mat-table [dataSource]="dataSource"
                      [multiTemplateDataRows]="true" matSort>
                <ng-container matColumnDef="table-name">
                  <th [attr.colspan]="matchesColsToDisplay.length" mat-header-cell *matHeaderCellDef>
                    <div class="space-between">
                      <span style="font-size: large;">
                        Subscriptions <small>(all amounts are in USD)</small> 
                        <span *ngIf="!!syndication && syndication.issuerPoolIsLocked" style="margin-left: 10px; font-weight: bold; color: red;">Subscription pool is LOCKED</span>
                      </span>
                      <button mat-raised-button (click)="showSubDocsTableOnly = true">Show Sub Docs Only</button>
                    </div>
                  </th>
                </ng-container>
                <!-- Investor -->
                <ng-container matColumnDef="businessUnit">
                  <th mat-header-cell *matHeaderCellDef> Investor</th>
                  <td mat-cell *matCellDef="let element" style="padding: 5px;">
                    <app-user-card [firstName]="element.investor.displayName"
                                    [displayName]="element.investor.profile"
                                    borderColor="transparent"
                                    sideColor="#ff0000"
                                    [image]="element.investor.imageUrl"
                    ></app-user-card>
                  </td>
                </ng-container>
                <!-- Subscription Amount -->
                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef> Subscription Amount</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.indicationAmount | currency: 'USD': 'symbol': '1.0-0' }}
                  </td>
                </ng-container>
                <!-- Notes -->
                <ng-container matColumnDef="notes">
                  <th mat-header-cell *matHeaderCellDef> Notes</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button
                            *ngIf="!!element.notes"
                            (click)="showNotes(element.notes)"
                            title="Show Notes"
                    >
                      <mat-icon color="primary">description</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <!-- Subscription Status -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef> Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ lookupService.getLookupValueForKey(lookupService.lookups.subscriptionStatus, element.status) }}
                  </td>
                </ng-container>
                <!-- Subscription Created -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef> Created</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.created | date : 'mediumDate' }}</span>
                      <span>{{ element.created | date : 'shortTime' }}</span>
                    </div>
                  </td>
                </ng-container>
                <!-- Subscription Actions -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-raised-button
                            color="primary"
                            *ngIf="element.showInitiateSubDocsButton"
                            (click)="openSubdocModal(element)"
                            title="Open SubDoc Modal"
                            [hasPermission]="util.Permission.CAN_ADD_DEAL_SUBDOCS"
                    >
                      Initiate Sub Doc...
                    </button>
                    &nbsp;
                    <button mat-icon-button
                            (click)="editAllocationModal(element)"
                            color="primary"
                            *ngIf="util.isAdmin() || util.isIssuer()"
                            title="View/Edit SubDoc"
                            [hasPermission]="util.Permission.CAN_EDIT_DEAL_SYNDICATION"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    &nbsp;
                    <button mat-icon-button
                            color="warn"
                            (click)="delete(element)"
                            *ngIf="util.isAdmin()"
                            title="Delete SubDoc"
                            [hasPermission]="util.Permission.CAN_DELETE_DEAL_SYNDICATION"
                      >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <!-- expand-->
                <ng-container matColumnDef="subdocs">
                  <th mat-header-cell *matHeaderCellDef aria-label="row actions">SubDocs</th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.subDocs.length == 0">none</span>
                    <button mat-icon-button title="Expand to see the SubDocs for this item"
                            aria-label="expand row"
                            (click)="element.expanded = !element.expanded"
                            *ngIf="element.subDocs.length > 0">
                      <mat-icon *ngIf="element.expanded" [matBadge]="element.subDocs.length" matBadgeColor="accent">keyboard_arrow_up</mat-icon>
                      <mat-icon *ngIf="!element.expanded" [matBadge]="element.subDocs.length" matBadgeColor="accent">keyboard_arrow_down</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <!-- Expanded Content Column -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell
                      class="expanded-detail-row" style="padding: 0px !important" 
                      *matCellDef="let element"
                      [attr.colspan]="matchesColsToDisplay.length">
                    <div class="element-detail" style="padding: 0px !important" 
                          [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'">
                      <!--                        -->
                      <!--   SUBDOC TABLE START   -->
                      <!--                        -->
                      <!--                        -->
                      <table class="subdoc-table pt-5 pb-5"
                              mat-table
                              [dataSource]="element.subDocs"
                              [multiTemplateDataRows]="true"
                              matSort
                      >
                        <!-- <ng-container matColumnDef="table-name">
                          <th colspan="6" mat-header-cell *matHeaderCellDef>
                            <span style="font-size: large;">Sub Docs</span>
                          </th>
                        </ng-container> -->
                        <!-- ENTITY -->
                        <ng-container matColumnDef="entity">
                          <th mat-header-cell *matHeaderCellDef> Entity</th>
                          <td mat-cell *matCellDef="let element" style="padding: 5px;">
                            <app-user-card [firstName]="element.entityName"
                                            [displayName]="element.entityType"
                                            [borderColor]="'transparent'"
                                            [sideColor]="'#004fe1'"
                            ></app-user-card>
                          </td>
                        </ng-container>
                        <!-- AMOUNT -->
                        <ng-container matColumnDef="amount">
                          <th mat-header-cell *matHeaderCellDef> SubDoc Amount</th>
                          <td mat-cell *matCellDef="let element">
                            <div>
                              <span
                                style="font-weight: bold; color: #986801">
                                {{ element.amount | currency: 'USD': 'symbol': '1.0-0' }}
                              </span>
                            </div>
                          </td>
                        </ng-container>
                        <!-- SUBDOC STATUS -->
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef> Subdoc Status</th>
                          <td mat-cell *matCellDef="let element">
                            {{ lookupService.getLookupValueForKey(lookupService.lookups.subDocStatus, element.status) }}
                          </td>
                        </ng-container>
                        <!-- DATE OF SUBSCRIPTION -->
                        <ng-container matColumnDef="date">
                          <th mat-header-cell *matHeaderCellDef> Date of Subscription</th>
                          <td mat-cell *matCellDef="let element">
                            <div class="date-stacked">
                              <span>{{ element.subscriptionDate | date : 'mediumDate' }}</span>
                              <span>{{ element.subscriptionDate | date : 'shortTime' }}</span>
                            </div>
        
                          </td>
                        </ng-container>
                        <!-- SUBDOC CREATED -->
                        <ng-container matColumnDef="created">
                          <th mat-header-cell *matHeaderCellDef> Sub Doc Created</th>
                          <td mat-cell *matCellDef="let element">
                            <div class="date-stacked">
                              <span>{{ element.created | date : 'mediumDate' }}</span>
                              <span>{{ element.created | date : 'shortTime' }}</span>
                            </div>
        
                          </td>
                        </ng-container>
                        <!-- ACTIONS -->
                        <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef> Actions</th>
                          <td mat-cell *matCellDef="let element">
                            <div style="display: flex;">
                              <!-- Rondeivu Fill and Approval for Investor -->
                              <button mat-raised-button
                                      color="primary"
                                      (click)="fillSubdoc(element, true)"
                                      *ngIf="element.showRondeivuApprovalButton"
                                      title="Approve SubDoc"
                                      [hasPermission]="util.Permission.CAN_EDIT_DEAL_SUBDOCS_APPROVE_ADMIN"
                                      [disabledOption1]="{ condition: syndication.issuerPoolIsLocked, message: 'Syndication pool is locked by issuer!' }" 
                              >
                                Review & Approve Sub Doc Data...
                              </button>
                              <!-- Investor Fill and Approval for Signatures -->
                              <button mat-raised-button
                                      color="primary"
                                      (click)="fillSubdoc(element, false)"
                                      *ngIf="element.showInvestorFillDataAndApproveButton"
                                      title="Fill/Approve SubDoc for Investor Signature"
                                      [hasPermission]="util.Permission.CAN_EDIT_DEAL_SUBDOCS_FILL_INVESTOR"
                                      [disabledOption1]="{ condition: syndication.issuerPoolIsLocked, message: 'Syndication pool is locked by issuer!' }" 
                              >
                                Fill & Approve for Investor review...
                              </button>
                              <!-- Open Subdoc view/edit Modal -->
                              <button mat-icon-button
                                      (click)="editSubdoc(element)"
                                      title="View/Edit SubDoc"
                                      [hasPermission]="util.Permission.CAN_ACCESS_DEAL_SUBDOCS"
                              >
                                <mat-icon>edit</mat-icon>
                              </button>
                              <!-- Download SubDoc PDF  -->
                              <button mat-icon-button
                                      (click)="downloadSubdoc(element)"
                                      title="View/Edit SubDoc"
                                      [hasPermission]="util.Permission.CAN_ACCESS_DEAL_SUBDOCS_PDF"
                              >
                                <mat-icon>download</mat-icon>
                              </button>
                              <!-- Delete SubDoc  -->
                              <button mat-icon-button
                                      color="warn"
                                      *ngIf="util.isAdmin()"
                                      (click)="deleteSubdoc(element)"
                                      title="Delete SubDoc"
                                      [hasPermission]="util.Permission.CAN_DELETE_DEAL_SUBDOCS"
                              >
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </td>
                        </ng-container>
                        <!-- Row Definitions -->
                        <!-- <tr mat-header-row *matHeaderRowDef="['table-name'];"></tr> -->
                        <tr mat-header-row *matHeaderRowDef="subdocCols; sticky:true;"></tr>
                        <tr mat-row class="subdoc-row" *matRowDef="let element; columns: subdocCols;"></tr>
                      </table>
                      <!--                        -->
                      <!--                        -->
                      <!--  SUBDOC TABLE END      -->
                      <!--                        -->
                      <!--                        -->
                    </div>
                  </td>
                </ng-container>
                <!-- Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="['table-name'];"></tr>
                <tr mat-header-row *matHeaderRowDef="matchesColsToDisplay; sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: matchesColsToDisplay;" class="element-row" [attr.id]="'syndication-' + element.id"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="subscription-detail-row"></tr>
              </table>
              <!--                -->
              <!-- SUBSCRIPTION TABLE START-->
              <!--                -->
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <!-- SubDocs only Table -->
    <div class="row justify-content-center d-none d-md-flex" *ngIf="showSubDocsTableOnly" style="padding-bottom: 150px; padding-top: 15px;">
      <div class="col-11">
        <div class="table-container">
          <div class="row table-inner-container">
            <div class="table-inner-inner-container">

              <table class="subscription-table"
                  mat-table [dataSource]="subDocsDataSource"
                  [multiTemplateDataRows]="true">
              
                <ng-container matColumnDef="table-name">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="subDocsOnlyTableColumns.length">
                    <div class="space-between">
                      <span style="font-size: large;">
                        Subscription Documents Only 
                      </span>
                      <button mat-raised-button (click)="showSubDocsTableOnly = false">Show Syndication Table with Sub Docs</button>
                    </div>
                  </th>
                </ng-container>

                <ng-container matColumnDef="investor">
                  <th mat-header-cell *matHeaderCellDef> Investing Entity</th>
                  <td mat-cell *matCellDef="let element">
                    <app-user-card [firstName]="element.entityName"
                                    [displayName]="element.entityType"
                                    [borderColor]="'transparent'"
                                    [sideColor]="'#004fe1'"
                    ></app-user-card>
                  </td>
                </ng-container>


                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef> Amount</th>
                  <td mat-cell *matCellDef="let element">{{element.amount | currency: 'USD': 'symbol': '1.0-0' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>SubDoc Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ lookupService.getLookupValueForKey(lookupService.lookups.subDocStatus, element.status) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef> Created</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.created | date : 'mediumDate' }}</span>
                      <span>{{ element.created | date : 'shortTime' }}</span>
                    </div>
                  </td>
                </ng-container>

                <!-- ACTIONS -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions</th>
                  <td mat-cell *matCellDef="let element">
                    <div style="display: flex;">
                      <!-- Rondeivu Fill and Approval for Investor -->
                      <button mat-raised-button
                              color="primary"
                              (click)="fillSubdoc(element, true)"
                              *ngIf="element.showRondeivuApprovalButton"
                              title="Approve SubDoc"
                              [hasPermission]="util.Permission.CAN_EDIT_DEAL_SUBDOCS_APPROVE_ADMIN"
                              [disabledOption1]="{ condition: syndication.issuerPoolIsLocked, message: 'Syndication pool is locked by issuer!' }" 
                              
                      >
                        Review & Approve Sub Doc Data...
                      </button>
                      <!-- Investor Fill and Approval for Signatures -->
                      <button mat-raised-button
                              color="primary"
                              (click)="fillSubdoc(element, false)"
                              *ngIf="element.showInvestorFillDataAndApproveButton"
                              title="Fill/Approve SubDoc for Investor Signature"
                              [hasPermission]="util.Permission.CAN_EDIT_DEAL_SUBDOCS_FILL_INVESTOR"
                              [disabledOption1]="{ condition: syndication.issuerPoolIsLocked, message: 'Syndication pool is locked by issuer!' }" 

                      >
                        Fill & Approve for Investor review...
                      </button>
                      <!-- Open Subdoc view/edit Modal -->
                      <button mat-icon-button
                              (click)="editSubdoc(element)"
                              title="View/Edit SubDoc"
                              [hasPermission]="util.Permission.CAN_ACCESS_DEAL_SUBDOCS"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <!-- Download SubDoc PDF  -->
                      <button mat-icon-button
                              (click)="downloadSubdoc(element)"
                              title="View/Edit SubDoc"
                              [hasPermission]="util.Permission.CAN_ACCESS_DEAL_SUBDOCS_PDF"
                      >
                        <mat-icon>download</mat-icon>
                      </button>
                      <!-- Delete SubDoc  -->
                      <button mat-icon-button
                              color="warn"
                              *ngIf="util.isAdmin()"
                              (click)="deleteSubdoc(element)"
                              title="Delete SubDoc"
                              [hasPermission]="util.Permission.CAN_DELETE_DEAL_SUBDOCS"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="['table-name'];"></tr>
                <tr mat-header-row *matHeaderRowDef="subDocsOnlyTableColumns; sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: subDocsOnlyTableColumns;" class="element-row" [attr.id]="'subdoc-' + element.id"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>



